import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NoosFormTypeService} from '../../../../../class/NoosFormTypeService';
import {IViewComponent} from '../../../../../interface/panels';
import {IFormItems} from '../../../../../interface/form-structure';

@Component({
    selector: 'noos-form-container-tab',
    templateUrl: './form-container-tab.component.html',
    styleUrls: ['./form-container-tab.component.scss']
})
@NoosFormTypeService.register('ViewFORMtab')
export class FormContainerTabComponent implements OnInit, IViewComponent, AfterViewInit {


    formJson: IFormItems[];
    isFilter: boolean;

    @Output()
    keyOnEnter = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;


    trackByForm(index: number, item: IFormItems): string {
        return item.form_guid;
    }

    constructor() {
    }

    ngOnInit() {
    }

    ngAfterViewInit(): void {

    }

    onEnterEvent($event: any) {
        this.keyOnEnter.emit();
    }


    getVisible(isVisible: boolean) {
        return isVisible === undefined ? true : isVisible;
    }
}
